import React from "react";
import { FaClock } from "react-icons/fa";

import tradingView from "@/assets/icons/tradingview.svg";
import chainIcon from "@/assets/icons/chainIcon.svg";
import Image from "next/image";
import {
    isFutures,
    isFuturesOrOptions,
    isOptions,
    statusColor,
    statusText,
    termColor,
    termText,
    toStockDetailFromTradeCard
} from "@/lib/tradeCards";
import { Mixpanel } from "@/elements/Mixpanel";
import { useRouter } from "next/router";
import WatchListButton from "../WatchListButton";
import Hint from "@/components/Hint";
import { TradeCardExitBtn } from "@/components/PlaceOrder/BuySellBtn";
import { cn, putComma } from "@/lib/utils";
import moment from "moment";
import { TradeChangeDetails } from "./LiveTradeIdeaCardV2";
import TradeHistoryPopUp from "./TradeHistoryPopUp";

export function ClosedTradeIdeaCard({ ele }) {
    const router = useRouter();
    const isDisabled = ["MCX-FUT", "MCX-OPT", "COMMODITY"].includes(ele?.term);

    return (
        <div className=" relative z-[4] w-full p-4 pt-8 rounded-2xl bg-[#C4E1F4]" id={ele?.id}>
            <div className="flex items-center gap-4 absolute -top-1 right-6">
                <div
                    className="flex border rounded-b pl-1 pr-2 py-[3px] justify-between items-center gap-2 bg-white relative"
                    style={{ borderColor: termColor(ele?.term), color: termColor(ele?.term) }}
                >
                    <svg
                        className="absolute -left-[7px] -right-[7px] -top-[1.5px] z-[-1]"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 109 6"
                        fill="none"
                    >
                        <path
                            d="M4.59519 0.953125H104.069L108.332 5.86222H0.332031L4.59519 0.953125Z"
                            fill={termColor(ele?.term)}
                        />
                    </svg>
                    <FaClock className="text-sm" />
                    <div className=" text-xs font-semibold">{termText(ele?.term)}</div>
                </div>
            </div>
            <div className="flex items-stretch trade-card gap-3">
                <ClosedTradeIdeaCardBody ele={ele} />

                <div className="w-[30%] flex flex-col gap-2 justify-between items-center self-stretch bg-white p-3 rounded-lg">
                    {moment(ele?.expiresAt).isBefore() ? (
                        <div className="" />
                    ) : (
                        <div className="flex w-full items-start gap-3">
                            <div
                                className={`w-full h-10 flex justify-center items-center flex-[1_0_0] border border-[#DFDFDF] bg-[#FFF] p-2 rounded-lg border-solid ${
                                    isDisabled ? "opacity-50 cursor-not-allowed" : ""
                                }`}
                            >
                                <WatchListButton
                                    watchListIds={ele?.watchListIds}
                                    finCode={ele?.finCode}
                                    exchange={ele?.exchange}
                                    pageName={"closed_trades"}
                                    symbol={ele?.stockName ?? ele?.compName}
                                    disabled={isDisabled}
                                />
                            </div>
                            <Hint label="Trading view" side={"left"}>
                                <div
                                    id="trading-view-button"
                                    className={`cursor-pointer w-full h-10 flex justify-center items-center flex-[1_0_0] border border-[#DFDFDF] bg-[#FFF] p-2 rounded-lg border-solid ${
                                        isDisabled ? "opacity-50 cursor-not-allowed" : ""
                                    }`}
                                    onClick={(e) => {
                                        if (!isDisabled) {
                                            Mixpanel.track("cta_clicked", {
                                                cta_text: "chart_view",
                                                page: "pro_trade_live",
                                                tab: ele?.term,
                                                tcard_type: ele?.term,
                                                fincode: ele?.finCode,
                                                symbol: ele?.stockName ?? ele?.compName
                                            });
                                            toStockDetailFromTradeCard(router.push, ele, "/charts");
                                        }
                                    }}
                                >
                                    <Image src={tradingView} alt="tradingView" className="min-w-[24px] h-6" />
                                </div>
                            </Hint>
                            {ele?.optionEnabled && (
                                <div
                                    className={`cursor-pointer h-10 flex justify-center items-center flex-[1_0_0] border border-[#DFDFDF] bg-[#FFF] p-2 rounded-lg border-solid ${
                                        isDisabled ? "opacity-50 cursor-not-allowed" : ""
                                    }`}
                                    onClick={(e) => {
                                        if (!isDisabled) {
                                            Mixpanel.track("cta_clicked", {
                                                cta_text: "chain_view",
                                                page: "pro_trade_live",
                                                tab: ele?.term,
                                                tcard_type: ele?.term,
                                                fincode: ele?.finCode,
                                                symbol: ele?.stockName ?? ele?.compName
                                            });
                                            toStockDetailFromTradeCard(router.push, ele, "/option-chain");
                                        }
                                    }}
                                >
                                    <Image src={chainIcon} alt="dkk" className="min-w-[16px]" />
                                </div>
                            )}
                        </div>
                    )}
                    <div className="flex flex-col justify-center items-center gap-2 self-stretch">
                        <TradeCardExitBtn
                            disabled={
                                moment(ele?.expiresAt).isBefore() ||
                                ["MCX-FUT", "MCX-OPT", "COMMODITY"].includes(ele?.term)
                            }
                            tradeCardData={ele}
                            finCode={ele?.finCode}
                            type={ele?.recommendationType}
                            symbol={ele?.compName}
                            source={"live_trades"}
                            tab={ele?.term}
                            ele={ele}
                            isClosed={true}
                        />
                        <TradeHistoryPopUp ele={ele}>
                            <ClosedTradeIdeaCardBody ele={ele} onBf={true} />
                        </TradeHistoryPopUp>
                    </div>
                </div>
            </div>
        </div>
    );
}
export function ClosedTradeIdeaCardBody({ ele, onBf, className }) {
    const router = useRouter();
    return (
        <div className={cn("w-[70%] flex flex-col items-center ", { "w-full": onBf }, className)}>
            <div
                className={cn("flex flex-col gap-4 items-center bg-white p-3 rounded-t-md w-full", {
                    "p-0 py-3": onBf
                })}
            >
                <div className="flex justify-between items-center self-stretch">
                    <div className="flex justify-between items-center self-stretch ">
                        <div
                            className="flex items-center gap-2 cursor-pointer"
                            onClick={() => {
                                toStockDetailFromTradeCard(router.push, { ...ele, compName: ele.name });
                            }}
                        >
                            {ele?.logoUrl ? (
                                <Image
                                    src={ele?.logoUrl}
                                    alt="stock logo"
                                    width={44}
                                    height={44}
                                    className="min-h-[44px] object-contain"
                                />
                            ) : (
                                <div className="h-11 w-11 font-Inter font-extrabold text-[24px] text-[#606060] bg-[#ededed] text-center py-1 rounded-full ">
                                    {ele?.title?.slice(0, 1)}
                                </div>
                            )}
                            <p className="text-black text-sm font-bold">{ele?.title}</p>
                        </div>
                    </div>
                    {ele?.closureReason && (
                        <div
                            className={`flex  text-sm justify-center items-center gap-2 rounded px-2 font-bold leading-6 ${
                                ele?.netGain >= 0 ? "text-[#26A649]" : "text-black"
                            }`}
                        >
                            {ele?.closureReason == "TARGET_HIT" ? "Target Hit" : "Profit Booked"}
                        </div>
                    )}
                </div>

                {!isFuturesOrOptions(ele?.term) && ele?.tradeCardModificationsList && (
                    <TradeChangeDetails
                        isFuturesCloseOrMCX={ele?.term?.includes("MCX-")}
                        tradeCardModificationsList={ele?.tradeCardModificationsList}
                    />
                )}

                {isFutures(ele?.term) && (
                    <TradeChangeDetails
                        isFuturesCloseOrMCX={true}
                        tradeCardModificationsList={[
                            {
                                date: moment(ele?.entryDateInLong).format("DD/MM/YY | hh:mm A"),
                                action: ele?.recommendationType,
                                price: ele?.entryPrice,
                                entryMin: ele?.suggestivePriceMin,
                                entryMax: ele?.suggestivePriceMax
                            },
                            {
                                date: moment(ele?.exitDateInLong).format("DD/MM/YY | hh:mm A"),
                                action: "Exit full",
                                price: ele?.closurePrice,
                                entryMin: ele?.suggestivePriceMin,
                                entryMax: ele?.suggestivePriceMax
                            }
                        ]}
                    />
                )}

                {isOptions(ele?.term) && ele?.tradeCardOptionsDataList && (
                    <>
                        <div className="bg-[#F5F5F5] border-y border-[#747474] w-full flex justify-between py-1 px-2.5">
                            <div className="text-[10px] font-medium text-[#606060]">
                                <b>Posted :</b>
                                {moment(ele?.entryDateInLong).format("DD MMM 'YY | hh:mm A")}
                            </div>
                            <div className="text-[10px] font-medium text-[#606060]">
                                <b>Closed :</b>
                                {moment(ele?.exitDateInLong).format("DD MMM 'YY | hh:mm A")}
                            </div>
                        </div>
                        <div className="w-full rounded-lg border border-solid border-[#C4E1F4] overflow-hidden">
                            <table className="w-full table-auto text-xs font-medium leading-5 ">
                                <thead>
                                    <tr className="text-left bg-[#C4E1F4]">
                                        <th className="px-2 py-1.5">Strategy (execute all)</th>
                                        {/* <th className="px-2 py-1.5">Ratio</th> */}
                                        <th className="px-2 py-1.5">Entry</th>
                                        <th className="px-2 py-1.5">Exit</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {ele?.tradeCardOptionsDataList?.map((option, i) => (
                                        <ClosedTradeOption key={i} optionDetails={option} />
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </>
                )}
            </div>
            <div
                style={{
                    backgroundColor: ele?.netGain >= 0 ? statusColor(ele?.closureReason) : "#FFF"
                }}
                className={cn("flex items-center gap-4 self-stretch py-1.5 rounded-b-lg", {
                    "rounded-none": onBf
                })}
            >
                <p
                    style={{
                        color: ele?.netGain >= 0 ? "#FFF" : statusColor(ele?.closureReason)
                    }}
                    className={`text-center w-full rounded-lg text-sm font-medium `}
                    dangerouslySetInnerHTML={{ __html: statusText(ele?.closureReason, ele) }}
                ></p>
            </div>
        </div>
    );
}

export function ClosedTradeOption({ optionDetails }) {
    return (
        <tr className="border-b border-[#EDEDED] text-xs font-semibold">
            <td className="px-2 py-1.5">
                <div className="flex items-center gap-2">
                    <p
                        className={`flex justify-center items-center rounded border ${
                            optionDetails?.recommendationType === "BUY"
                                ? "border-[#148F36] text-[#148F36] "
                                : "border-[#EB4E2C] text-[#EB4E2C]"
                        }  px-[5px] py-0.5 border-solid  text-center text-[8px] font-bold leading-3 `}
                    >
                        {optionDetails?.recommendationType === "BUY" ? "Buy" : "Sell"}
                    </p>
                    {optionDetails?.symbol}
                </div>
            </td>
            {/* <td className="px-2 py-1.5">{putComma(optionDetails?.ratio ?? "0", 0)}</td> */}
            <td className="px-2 py-1.5">₹{putComma(optionDetails?.suggestedPrice ?? "0.00")}</td>
            <td className="px-2 py-1.5"> ₹{putComma(optionDetails?.closurePrice)}</td>
        </tr>
    );
}
